export default {
  namespaced: true,
  state: {
    printMyWorksModalVisible: false,
    printStudentsWorksModalVisible: false,
    printClassroomWorksModalVisible: false,
    printDetailsModalVisible: false,
    commentWorkModalVisible: false,
    aboutModalVisible: false
  },
  getters: {
    state: (state) => state
  },
  actions: {
    togglePrintMyWorksModalVisible ({ commit }) {
      commit('togglePrintMyWorksModalVisible')
    },
    togglePrintStudentWorksModalVisible ({ commit }) {
      commit('togglePrintStudentWorksModalVisible')
    },
    togglePrintClassroomWorksModalVisible ({ commit }) {
      commit('togglePrintClassroomWorksModalVisible')
    },
    togglePrintDetailsModalVisible ({ commit }) {
      commit('togglePrintDetailsModalVisible')
    },
    toggleCommentWorkModalVisible ({ commit }) {
      commit('toggleCommentWorkModalVisible')
    },
    toggleAboutModalVisible ({ commit }) {
      commit('toggleAboutModalVisible')
    }
  },
  mutations: {
    togglePrintMyWorksModalVisible (state) {
      state.printMyWorksModalVisible = !state.printMyWorksModalVisible
    },
    togglePrintStudentWorksModalVisible (state) {
      state.printStudentsWorksModalVisible = !state.printStudentsWorksModalVisible
    },
    togglePrintClassroomWorksModalVisible (state) {
      state.printClassroomWorksModalVisible = !state.printClassroomWorksModalVisible
    },
    togglePrintDetailsModalVisible (state) {
      state.printDetailsModalVisible = !state.printDetailsModalVisible
    },
    toggleCommentWorkModalVisible (state) {
      state.commentWorkModalVisible = !state.commentWorkModalVisible
    },
    toggleAboutModalVisible (state) {
      state.aboutModalVisible = !state.aboutModalVisible
    }
  }
}
